<div class="row  justify-content-center">
    <div class="col-10">
        <h1 class="clem-font autopartage marge">Mes réservatoions</h1>
      </div>
  <div class="col-12">
    <div class="row">
      <div class="col-12 ">
        <div class="">
          <app-next-book [bookList]=bookList (openMapEvent)='displayLeafletDialog($event)'></app-next-book>
        </div>
      </div>
      <div class="col-12 ">
        <div class="">
          <app-last-station [bookList]="bookList"></app-last-station>
        </div>
      </div>

      <div class="col-12 ">
        <div class="">
          <app-last-station [bookList]="bookList"></app-last-station>
        </div>
      </div>
      <!-- <div class="col-12">
        <div class="">
          <app-eco-bilan-resume [user]="currentUser"></app-eco-bilan-resume>
        </div>
      </div> -->
    </div>
  </div>
</div>
